<template>
    <div class="d-flex flex-row w-100">
        <div class="leftcolumn  flex-grow-1">
            <CompanyList
                chatFilterButton
                :data="featuredCompanies"
                label="Companies"
                class="mb-4"
                :resolveroute="companyClickRoute"
                :isLoading="companiesLoading && chatUserSummaryLoading()"
                :chat-availability="chatUserSummaryData()"
            ></CompanyList>
            <PostingModule
                :data="jobs"
                class="mb-4"
                label="Featured positions"
                :resolveroute="resolveRoute"
            ></PostingModule>
        </div>
        <div class="rightcolumn">
            <ProfileModule :mini="true" class="mb-4"></ProfileModule>
            <EventList :value="events" :vFairId="$route.params.id" class="mb-4"></EventList>
        </div>
    </div>
</template>

<script>
import CompanyList from '~/shared/CompanyList';
import PostingModule from '~/shared/postingmodule/PostingModule';
import ProfileModule from '~/components/smart/ProfileModule/ProfileModule';
import EventList from './components/EventList';
import { SHOW_CHAT_IN_COMPANY_LIST } from '~/router';

export default {
    name: 'Home',
    components: {
        CompanyList,
        PostingModule,
        ProfileModule,
        EventList,
    },
    data() {
        return {};
    },
    computed: {
        chatUserSummary() {
            return SHOW_CHAT_IN_COMPANY_LIST
                ? this.$interfaces.communication.chat.availability.summary.get({
                      reactive: true,
                  })
                : [];
        },
        companiesRequest() {
            if (this.$route.params.id) {
                return this.$interfaces.vfair.id(this.$route.params.id).organizations.get({
                    reactive: true,
                });
            } else {
                return { loading: true };
            }
        },
        companiesLoading() {
            return this.companiesRequest.loading;
        },
        companies() {
            if (this.companiesRequest.loading) {
                return [];
            } else {
                return this.companiesRequest.data.filter(item => {
                    if (item) {
                        return item.status === 2;
                    }
                    return false;
                });
            }
        },
        featuredCompanies() {
            return this.companies.map(org => {
                return {
                    id: org.organizationId,
                    logo: org.logo,
                    name: org.title,
                };
            });
        },
        events() {
            if (this.$route.params.id) {
                return this.$interfaces.vfair.id(this.$route.params.id).events.get({
                    reactive: true,
                }).data;
            } else {
                return { loading: true };
            }
        },
        jobs() {
            return this.$interfaces.posting.get({
                reactive: true,
                vfair_id: this.$route.params.id,
                mode: 'featured',
            }).data;
        },
    },
    methods: {
        chatUserSummaryData() {
            return this.chatUserSummary.data;
        },
        chatUserSummaryLoading() {
            return this.chatUserSummary.loading;
        },
        companyClickRoute(id) {
            const url = this.$URLS.vfair
                .concat('/', this.$route.params.id)
                .concat('/companies/', id);
            return url;
        },
        resolveRoute(jobAdId) {
            const url = this.$URLS.vfair
                .concat('/', this.$route.params.id)
                .concat('/jobs/', jobAdId);
            return url;
        },
    },
    mounted() {},
};
</script>

<style scoped>
.leftcolumn {
    min-width: 65%;
    margin-right: 22px;
}
</style>
